import './index.css'

import ErrorPage from '@reader-tracker/shared/core/Error'
import { MainLayout } from '@reader-tracker/shared/layouts/Main'
import { UserCallbackPage } from '@reader-tracker/shared/pages/auth/Callback'
import { LoginPage } from '@reader-tracker/shared/pages/auth/LoginPage'
import { LogsProvider } from '@reader-tracker/shared/providers/Logs'
import { useAuthListener } from '@reader-tracker/shared/stores/authStore'
import { RouterProvider, createBrowserRouter } from 'react-router-dom'
import { APP_NAME, NAV_ITEMS } from './navbar.config'
import AboutPage from './pages/About/About'
import HabitPage from './pages/Habit/Habit'
import SettingsPage from './pages/Settings/Settings'
import StatsPage from './pages/Stats/Stats'

const habitLayout = (children: React.ReactNode): React.ReactElement => (
  <MainLayout appName={APP_NAME} navItems={NAV_ITEMS}>
    {children}
  </MainLayout>
)

const router = createBrowserRouter([
  {
    path: '/',
    element: habitLayout(<HabitPage />),
    errorElement: <ErrorPage />,
  },
  {
    path: '/stats',
    element: habitLayout(<StatsPage />),
    errorElement: <ErrorPage />,
  },
  {
    path: '/settings',
    element: habitLayout(<SettingsPage />),
    errorElement: <ErrorPage />,
  },
  {
    path: '/about',
    element: habitLayout(<AboutPage />),
    errorElement: <ErrorPage />,
  },
  {
    path: '/auth/login',
    element: habitLayout(<LoginPage />),
    errorElement: <ErrorPage />,
  },
  {
    path: '/auth/callback',
    element: habitLayout(<UserCallbackPage adminRedirectPath="/" />),
    errorElement: <ErrorPage />,
  },
])

function App(): React.ReactElement {
  useAuthListener()
  return (
    <LogsProvider>
      <RouterProvider router={router} />
    </LogsProvider>
  )
}

export default App
